<template>
  <div>
    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">数字资产工具包插件用户指南</p>
              <div class="download">
                <div class="d-left">
                  <a
                    class="chrome-extension-down"
                    href="https://www.hwelltech.com/HWTool.zip"
                    target="view_blank"
                  >
                    <span>数字资产工具包插件下载</span>
                    <span class="version" v-if="chromeExtensionVersion"
                      >V{{ chromeExtensionVersion }}</span
                    >
                  </a>
                </div>
              </div>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/product/digitization/chrome-part.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2" id="part-2">
          <div class="main">
            <div :class="['doc-nav', fixedNav ? 'fixed-nav' : '']">
              <ul class="nav-list">
                <li
                  :class="{ active: item.id === docNavActive }"
                  v-for="item in docNavList"
                  :key="item.id"
                  @click="scrollElem(item.id)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="doc-content">
              <div class="par" ref="par1" id="par1">
                <h3 class="par-title">一、数字资产工具包插件的安装</h3>
                <div class="par-content">
                  <p>
                    1. 数字资产工具包插件（HWTool插件）的安装，点击本页“<a
                      href="https://www.hwelltech.com/HWTool.zip"
                      target="view_blank"
                      >数字资产工具包插件下载</a
                    >”按钮，下载最新的数字资产工具包插件安装包。
                  </p>
                  <p>2. 对下载的压缩包进行解压缩。</p>
                  <img
                    src="../../../assets/images/pc/product/chrome/1.png"
                    alt=""
                  />
                  <p>
                    3. 下载谷歌chrome浏览器，<a
                      href="https://www.google.cn/chrome/"
                      target="view_blank"
                      >https://www.google.cn/chrome/</a
                    >。下载完成后，安装chrome浏览器。
                  </p>
                  <p>
                    4.
                    打开Chrome浏览器并单击右上角的“更多工具”，然后单击“扩展程序”。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/2.png"
                    alt=""
                  />
                  <p>5. 开启开发者模式。</p>
                  <img
                    src="../../../assets/images/pc/product/chrome/3.png"
                    alt=""
                  />
                  <p>
                    6.
                    点击“加载已解压的扩展程序”，然后选择之前解压好的工具包文件夹。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/4.png"
                    alt=""
                  />
                  <p>
                    7.
                    添加成功后，点击Chrome浏览器右上角“拼图”图标。选择“HWTool”，即可打开数字资产工具包插件。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/5.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="par" ref="par2" id="par2">
                <h3 class="par-title">二、数字资产工具包插件的升级</h3>
                <div class="par-content">
                  <p>
                    1.
                    进入数字资产工具包插件的首页，如果有新的版本升级，会弹出升级提示。点击“立即升级”会跳转到本页。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/6.png"
                    alt=""
                  />
                  <p>
                    2. 点击本页“<a
                      href="https://www.hwelltech.com/HWTool.zip"
                      target="view_blank"
                      >数字资产工具包插件下载</a
                    >”按钮，下载最新的数字资产工具包插件安装包。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/7.png"
                    alt=""
                  />
                  <p>
                    3.
                    解压后，将文件夹里面的所有文件复制替换到，数字资产工具包插件之前安装的文件夹中（<span
                      class="tips"
                      >将之前安装文件夹里面所有子文件都先删除，安装文件夹不要更改文件名和移动位置，如果更改文件名或移动文件位置会导致插件不能正常使用以及数据丢失</span
                    >）。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/8.png"
                    alt=""
                  />
                  <p>
                    4.
                    点击chrome浏览器右上角拼图图标，管理扩展程序，打开扩展程序管理界面。
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/9.png"
                    alt=""
                  />
                  <p>
                    5.
                    找到数字资产工具包插件（HWTool）的扩展程序，点击刷新按钮。版本号发生变化，说明版本已经升级成功。（<span
                      class="tips"
                      >请一定保证新的安装包中的文件已经完整的复制进旧的安装文件夹，再点击刷新。不然可能导致插件无法正常更新使用</span
                    >）
                  </p>
                  <img
                    src="../../../assets/images/pc/product/chrome/10.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="par" ref="par3" id="par3">
                <h3 class="par-title">三、数字资产工具包插件的使用</h3>
                <div class="par-content">
                  <p>
                    数字资产工具包插件的使用，请阅读<a
                      href="https://apidocs.hwelltech.com/chrome-extensions-using"
                      target="view_blank"
                      >https://apidocs.hwelltech.com/chrome-extensions-using</a
                    >文档。
                  </p>
                </div>
              </div>
              <div class="par" ref="par4" id="par4">
                <h3 class="par-title">四、API的使用</h3>
                <div class="par-content">
                  API的使用，请阅读以下文档
                  <p>
                    <a
                      href="https://apidocs.hwelltech.com/chrome-extensions-query-api"
                      target="view_blank"
                      >https://apidocs.hwelltech.com/chrome-extensions-query-api</a
                    >
                  </p>
                  <p>
                    <a
                      href="https://apidocs.hwelltech.com/chrome-extensions-transaction-api"
                      target="view_blank"
                      >https://apidocs.hwelltech.com/chrome-extensions-transaction-api</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";
import axios from "axios";
export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
  },
  data() {
    return {
      cn: false,
      en: false,
      chromeExtensionVersion: null, //chrome扩展程序版本
      docNavActive: 1, //文档导航高亮
      fixedNav: false, //导航固定
      docNavList: [
        //文档导航
        {
          id: 1,
          name: "插件的安装",
        },
        {
          id: 2,
          name: "插件的升级",
        },
        {
          id: 3,
          name: "插件的使用",
        },
        {
          id: 4,
          name: "API的使用",
        },
      ],
    };
  },
  mounted() {
    let that = this;
    this.init(); //初始化
    window.addEventListener("scroll", that.handleScroll); //监听页面滚动
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
    /*初始化页面*/
    init() {
      this.mobile();
      this.getExtensionsConfig(); //获取chrome扩展程序的版本信息
      if (this.$route.query && this.$route.query.doc) {
        // this.scrollElem(Number(this.$route.query.doc)); //跳转到相应段落
        setTimeout(() => {
          this.scrollElem(Number(this.$route.query.doc)); //跳转到相应段落
        }, 300);
      }
    },
    /*获取chrome扩展程序的版本信息*/
    getExtensionsConfig() {
      let url =
        process.env.NODE_ENV == "development"
          ? `/api/extensionsConfig.json?time=${new Date().getTime()}`
          : `/extensionsConfig.json?time=${new Date().getTime()}`;
      axios
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.version)
              this.chromeExtensionVersion = res.data.version;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get("/hw/api/admin/noauth/showError")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*监听页面滚动*/
    handleScroll() {
      let oDoc = document.querySelector("#part-2");
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= oDoc.offsetTop) {
        //超过文档位置固定导航
        this.fixedNav = true;
      } else {
        this.fixedNav = false;
      }
      this.docNavList.forEach((item, i) => {
        let refId = `par${item.id}`;
        let elemItem = document.querySelector(`#${refId}`);
        if (scrollTop >= elemItem.offsetTop) {
          this.docNavActive = item.id; //当前点击按钮高亮
        }
      });
    },
    /*滚动到相应段落*/
    scrollElem(key) {
      let findIndex = this.docNavList.find((item) => Number(key) === item.id);
      key = /^\d+$/.test(key) && findIndex ? key : 1;
      this.docNavActive = key; //当前点击按钮高亮
      this.$nextTick(() => {
        let elemId = this.$refs[`par${key}`]; //通过段落id获取段落
        document.documentElement.scrollTop = elemId.offsetTop;
        document.body.scrollTop = elemId.offsetTop; // chrome
      });
    },
  },
  destroyed() {
    //离开页面，销毁监听页面滚动事件
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(171deg, #1d3ede, #108eea);
    .main {
      .clearfix();
    }
    .left {
      width: 50%;
      float: left;
      .tit {
        .hTit();
        margin: 193px 0 10px 0;
      }
      .text {
        width: 522px;
        .hText();
      }
      .download {
        display: flex;
        justify-content: flex-start;
        .d-left {
          .chrome-extension-down {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 23px;
            padding: 0 20px;
            margin-top: 20px;
            cursor: pointer;
            span {
              display: inline-block;
              color: #fff;
              font-size: 16px;
            }
            .version {
              padding-left: 15px;
              margin-left: 15px;
              position: relative;
              &::before {
                content: "";
                width: 1px;
                height: 70%;
                background: #ffffff;
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
              }
            }
          }
        }
        .d-right {
          text-align: center;
          margin-left: 55px;
          padding-top: 28px;
          img {
            width: 100px;
          }
          p {
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
    .right {
      width: 50%;
      float: left;
      img {
        margin: 60px 0 0 170px;
        width: 358px;
        height: 400px;
      }
    }
  }
  .part-2 {
    .main {
      .clearfix();
      height: 100%;
      padding: 40px 0;
      // display: flex;
      color: #666666;
      .doc-nav {
        display: inline-block;
        width: 140px;
        text-align: center;
        &.fixed-nav {
          position: fixed;
          top: 20px;
        }
        li {
          width: 100%;
          font-size: 14px;
          padding: 10px 20px;
          margin: 5px 0;
          cursor: pointer;
          &:hover,
          &.active {
            border-radius: 3px;
            color: #ffffff;
            background: @active;
          }
        }
      }
      .doc-content {
        display: inline-block;
        max-width: calc(1140px - 140px);
        min-width: calc(1024px - 140px);
        line-height: 2;
        padding: 0 40px;
        float: right;
        box-sizing: border-box;
        .par-title {
          color: #333333;
          margin-bottom: 5px;
        }
        p {
          // margin-bottom: 10px;
          .tips {
            font-weight: bold;
          }
        }
        img {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>